export enum PassType {
  Event = 'event',
  Champion = 'champion',
  Master = 'master',
}
